import { render, staticRenderFns } from "./BacklogDesativacaoPage.vue?vue&type=template&id=14d22cde"
import script from "./BacklogDesativacaoPage.vue?vue&type=script&lang=js"
export * from "./BacklogDesativacaoPage.vue?vue&type=script&lang=js"
import style0 from "./BacklogDesativacaoPage.vue?vue&type=style&index=0&id=14d22cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports